import { networkType, RPC_MAP, SERVICE_API_URL } from "@/config";
import sdk from "@/libs/spheron-sdk";
import { Contract, ethers, JsonRpcProvider } from "ethers";
import RewardsManagerAbi from "@/contracts/abis/FizzRewardsManager.json";
import { mapTokenToId } from "@/utils";
import { addressMap } from "@/contracts/addresses";

export const getBaseRewardsPerEra = async (category: string) => {
  if (category === "CPU") {
    return 25000000000000000000;
  } else {
    return 500000000000000000000;
  }
  // const provider = new JsonRpcProvider(SPHERON_DEVNET_RPC_URL);
  // const contractAbi = RewardsManagerAbi;
  // const contractAddress = FizzRewardsManagerDev;
  // const contract: Contract = new ethers.Contract(
  //   contractAddress,
  //   contractAbi,
  //   provider
  // );
  // const response = await contract.getFizzBaseRewardsPerEra(category);

  // return response;
};

export const getProviderAttrs = async (
  fizzAddress: string,
  category: string
) => {
  const response = await sdk.fizz.getAttributes(fizzAddress, category);
  console.log("attr ids -> ", response);
  return response;
};

export const getFizzNodeRewardsPerEra = async (
  fizzNodeAddress: string,
  isRegistered: boolean
  // trustMultiplier: number
) => {
  console.log({ isRegistered });
  // if (isRegistered) {
  //   return 0;
  // }
  const provider = new JsonRpcProvider(RPC_MAP[networkType].http);
  const contractAbi = RewardsManagerAbi;
  const contractAddress = addressMap[networkType].fizzRewardsManager;
  const contract: Contract = new ethers.Contract(
    contractAddress,
    contractAbi,
    provider
  );
  const response = await contract.getFizzRewardsPerEra(fizzNodeAddress);
  const rewardsPerEra = Number(response);

  console.log("rewards per era -> ", rewardsPerEra);

  // return (rewardsPerEra * trustMultiplier) / 10;

  return rewardsPerEra;
};

export const getIsFizzNodePaused = async (fizzNodeAddress: string) => {
  const provider = new JsonRpcProvider(RPC_MAP[networkType].http);
  const contractAbi = RewardsManagerAbi;
  const contractAddress = addressMap[networkType].fizzRewardsManager;
  const contract: Contract = new ethers.Contract(
    contractAddress,
    contractAbi,
    provider
  );
  const response = await contract.isPausedFizz(fizzNodeAddress);

  return response;
};

export const getRewardsBreakdown = async (
  fizzAddress: string,
  category: string
): Promise<any[] | null> => {
  try {
    const pendingAttributeIds: { id: bigint; units: bigint }[] =
      await getProviderAttrs(fizzAddress, category);

    console.log(
      "Pending Attribute IDs:",
      pendingAttributeIds.map((attr) => attr.id)
    );

    const resources: any[] = await Promise.all(
      pendingAttributeIds.map(async (attr) => {
        const { name, tier, multiplier } = await sdk.fizz.getResource(
          attr.id,
          category
        );
        return {
          id: attr.id.toString(),
          name,
          tier,
          multiplier: (Number(multiplier) / 100).toString(),
          count: Number(attr.units),
        };
      })
    );

    console.log("Resources -> ", resources);
    return resources;
  } catch (error) {
    console.error("Error fetching rewards breakdown:", error);
    return null;
  }
};

export const getTotalRewardsForFizz = async (
  fizzAddress: string,
  isVerified: boolean
) => {
  if (!isVerified) {
    return 0;
  }
  const provider = new JsonRpcProvider(RPC_MAP[networkType].http);
  const contractAbi = RewardsManagerAbi;
  const contractAddress = addressMap[networkType].fizzRewardsManager;

  const contract: Contract = new ethers.Contract(
    contractAddress,
    contractAbi,
    provider
  );
  const currentRewards = await contract.getAccRewardsForFizz(fizzAddress);
  const pendingRewards = await contract.pendingRewards(fizzAddress);
  const totalRewards = currentRewards;

  console.log("currentRewards -> ", currentRewards);
  console.log("pendingRewards -> ", pendingRewards);
  console.log("total rewards -> ", totalRewards);

  return totalRewards;
};

export const getTotalRewards = async (
  fizzNodeAddress: string,
  isRegistered: boolean,
  perEraRewardData?: number
) => {
  // if (isRegistered) {
  //   return 0;
  // }
  const provider = new JsonRpcProvider(RPC_MAP[networkType].http);
  const contractAbi = RewardsManagerAbi;
  const contractAddress = addressMap[networkType].fizzRewardsManager;
  const contract: Contract = new ethers.Contract(
    contractAddress,
    contractAbi,
    provider
  );
  const currentEra = await contract.getCurrentEra();
  const currentProvider = await contract.fizzez(fizzNodeAddress);
  console.log("current era -> ", currentEra);
  console.log("last claimed era -> ", currentProvider.lastClaimedEra);
  // console.log("per era rewards -> ", perEraRewardData);
  // const eraElapsed = Number(currentEra - currentProvider.lastClaimedEra);
  // const currentRewards = BigInt(perEraRewardData * eraElapsed);
  const currentRewards = await contract.getAccRewardsForFizz(fizzNodeAddress);
  // const pendingRewards = await contract.pendingRewards(fizzNodeAddress);
  const pendingRewards = BigInt(0);
  const totalRewards = currentRewards + pendingRewards;

  console.log("currentRewards -> ", currentRewards);
  console.log("pendingRewards -> ", pendingRewards);
  console.log("total rewards -> ", totalRewards);

  return totalRewards;
};

export const getProviderRewardsPerEra = async (
  fizzAddress: string,
  isVerified: boolean
) => {
  if (!isVerified) {
    return 0;
  }
  const provider = new JsonRpcProvider(RPC_MAP[networkType].http);
  const contractAbi = RewardsManagerAbi;
  const contractAddress = addressMap[networkType].fizzRewardsManager;

  const contract: Contract = new ethers.Contract(
    contractAddress,
    contractAbi,
    provider
  );
  const response = await contract.getFizzRewardsPerEra(fizzAddress);
  const rewardsPerEra = Number(response) / 100;

  console.log("rewards per era -> ", rewardsPerEra);

  return rewardsPerEra;
};

export const getLiveTokenPrice = async (token?: string): Promise<any> => {
  if (token == null || token.trim() === "") {
    console.error("getLiveTokenPrice: token is undefined or empty");
    throw new Error("Token is required to fetch live price");
  }

  try {
    const response = await fetch(
      `${SERVICE_API_URL}/v1/price/liveTokenPrice/${mapTokenToId(token)}`
    );
    return response.json();
  } catch (error) {
    console.error("Error in getLiveTokenPrice:", error);
    // showToastNotification({
    //   message: JSON.stringify(error),
    //   type: NotificationType.Error,
    //   timestamp: Date.now(),
    // });
  }
};

export const getLiveTokenPriceCoinGecko = async (token?: string): Promise<any> => {
  if (token == null || token.trim() === "") {
    console.error("getLiveTokenPrice: token is undefined or empty");
    throw new Error("Token is required to fetch live price");
  }

  try {
    const response = await fetch(`https://api.coingecko.com/api/v3/simple/price?vs_currencies=usd&ids=${token}`);
    const data = await response.json();
    return data[token].usd;
  } catch (error) {
    console.error("Error in getLiveTokenPrice:", error);
    // showToastNotification({
    //   message: JSON.stringify(error),
    //   type: NotificationType.Error,
    //   timestamp: Date.now(),
    // });
  }
};

export interface Resource {
  id: string;
  name: string;
  tier: string;
  multiplier: string;
  count: number;
}
